<template>
  <div class="container mt-90">
    <wfh-toast :display="showNotification"></wfh-toast>
    <div class="row pt-4" ref="top">
      <div class="col">
        <a href="/dashboard" class="link-btn">
          <i class="fa fa-angle-left mr-3"></i>
          Back to Task
        </a>
      </div>
    </div>

    <div class="row mt-3 text-center">
      <div class="col-12 col-md-8 mx-auto">
        <h1 class="page-title" ref="top">Open Tasks</h1>
        <p class="page-description">These tasks are open for anyone in team to pickup. Once your request have
          been approved, the task will be visible on your task homepage.</p>
      </div>
    </div>

    <div class="row py-3">
      <div class="col-12 col-md-5 mx-auto">
        <v-select
            id="companies"
            :options="companies"
            v-model="selectedCompany"
            label="name"
            :filterable="false"
            :clearable="false"
        >
        </v-select>
      </div>
    </div>

    <div class="row py-4 align-content-center" style="min-height: 350px;"
         v-if="componentReady && tasks.length === 0">
      <div class="col-12 col-md-7 mx-auto text-center">
        <img src="/images/EmptyState.svg" alt="No Assigned Tasks">
      </div>
      <div class="col-12 col-md-7 mx-auto text-center mt-3">
        <div class="empty-state-title">No Task Yet</div>
        <p class="empty-state-description">We are searching for the right task for you, please come back
          later </p>
      </div>
    </div>

    <div class="row py-4">
      <div class="col-12 col-md-8 mx-auto tasks-list" v-for="task in tasks">
        <open-tasks-detail
            :task="task"
            :isLoading="loading === task.id"
            @pickUpTask="pickUpTask"
        ></open-tasks-detail>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import moment from 'moment';
import Task from './Task';

export default {
  components: { vSelect },

  data () {
    return {
      companies: [],
      selectedCompany: {
        name: 'All Companies',
      },
      tasks: [],
      loading: null,
      showNotification: 0,
      componentReady: false,
      taskService: Task,
    };
  },

  watch: {
    async selectedCompany () {
      await this.fetchOpenTasks();
    },
  },

  methods: {
    async fetchOpenTasks () {
      const filters = {
        assigned_to: 'external',
        company_id: this.selectedCompany.id,
        range: 90,
        status: 'pending_pickup',
        for_external: true,
      };

      const res = await this.taskService.fetchTasks(filters);
      this.tasks = res.data;
      this.componentReady = true;
    },

    async fetchUserCompanies () {
      const res = await axios.get('/get-user-companies');
      this.companies = [
        {
          name: 'All Companies',
        },
        ...res.data.data,
      ];
    },

    async pickUpTask (taskId) {
      this.loading = taskId;

      try {
        await axios.post(`/tasks/${taskId}/pick-up`);
        this.tasks = this.tasks.filter(task => {
          return task.id !== taskId;
        });
      } finally {
        this.$refs['top'].scrollIntoView({ block: 'end', behavior: 'smooth' });
        this.showNotification++;
        this.loading = null;
      }
    },
  },

  mounted () {
    this.fetchOpenTasks();
    this.fetchUserCompanies();
  },
};
</script>

<style scoped lang="scss">
.page-title {
  color: #303030;
  font-family: Lato, serif;
  font-size: 38px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 53.2px;
}

.page-description {
  color: #606064;
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 28px;
}

.mt-90 {
  margin-top: 90px;
}

.link-btn {
  display: flex;
  align-items: center;
  color: #0db4e6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0;

  .fas {
    color: #3593fe !important;
  }
}

.tasks-list:not(:last-child) {
  border-bottom: 1px solid #d5d5d5;
  padding-bottom: 24px;
  margin-bottom: 24px;
}

.empty-state-title {
  color: #333;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
}

.empty-state-description {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  padding: 12px 0;
}
</style>
